import MessagingPage from './MessagingPage';

export default MessagingPage;
